interface LoggerConfig {
  isLogToConsole?: boolean;
  isLogToServer?: boolean;
  logToServerURL?: string;
}

let LoggerConfig: LoggerConfig = {
  isLogToConsole: true,
  isLogToServer: false,
  logToServerURL: '',
};

const getLoggerConfig = () => LoggerConfig;
const setLoggerConfig = (config: LoggerConfig) => (LoggerConfig = { ...LoggerConfig, ...config });

export { getLoggerConfig, LoggerConfig, setLoggerConfig };
